import React, { Component } from 'react';
import { connect } from "react-redux";

import {cannedResponse} from "../../../actions/actions";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class CannedResponse extends Component {

    constructor(props) {
        super(props);
        this.state={
            "showMenu":false,
            "removeMenu":false,
            "editForm":false,
            "shortcut_value":"",
            "response_value":"",
            "button_disabled":false
        }
        this.onMouseOver=this.onMouseOver.bind(this);
        this.onMouseOut=this.onMouseOut.bind(this);
        this.removeMenu=this.removeMenu.bind(this);
        this.editForm=this.editForm.bind(this);
        this.editFormClose=this.editFormClose.bind(this);
        this.onchangeResponse=this.onchangeResponse.bind(this);
        this.onchangeShortcut=this.onchangeShortcut.bind(this);
        this.editResponse=this.editResponse.bind(this);
        this.deleteResponse=this.deleteResponse.bind(this);
    }

    onchangeResponse(e){
        this.setState({
            "response_value":e.target.value.trim()
        });
        if(e.target.value.trim().length>0 && this.state.shortcut_value.trim().length>0){
            this.setState({
                "button_disabled":false
            })
        } else{
            this.setState({
                "button_disabled":true
            })
        }
    }
    onchangeShortcut(e){
        this.setState({
            "shortcut_value":e.target.value.trim()
        });
        if(e.target.value.trim().length>0 && this.state.response_value.trim().length>0){
            this.setState({
                "button_disabled":false
            })
        } else{
            this.setState({
                "button_disabled":true
            })
        }
    }

    deleteResponse(){
        this.props.dispatch(cannedResponse({
            action:"delete",
            id:this.props.data.id
        }));
    }
    editResponse(){
        if(this.state.response_value.trim().length>0 && this.state.shortcut_value.trim().length>0){
            this.props.dispatch(cannedResponse({
                action:"update",
                id:this.props.data.id,
                shortcut:this.state.shortcut_value.trim(),
                desc:this.state.response_value.trim()
            }));

            this.setState({
                editForm:false
            });
        }
    }
    onMouseOver(){

        this.setState({
            "showMenu":true,

        })
    }
    editFormClose(){
        this.setState({
            "editForm":false,

        })
    }
    editForm(){
        this.setState({
            "editForm":true,

        })
    }

    removeMenuClose(){
        this.setState({
            "removeMenu":false,

        })
    }
    removeMenu(){
        this.setState({
            "removeMenu":true,

        })
    }
    onMouseOut(){
        this.setState({
            "showMenu":false,

        })
    }


    componentWillMount() {
        this.setState({
            "shortcut_value":this.props.data.shortcut,
            "response_value":this.props.data.message,
        });
    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="response"
                     onMouseEnter={this.onMouseOver.bind(this)}
                     onMouseLeave={this.onMouseOut.bind(this)}
                >
                    <div className="view">

                        <div className={"edit "+(this.state.editForm ? 'show' : 'hide') }>

                            <div className={"canned-responses-form "+(this.state.editForm ? 'show' : 'hide') }>
                                <div className="form">
                                    <div>
                                        <textarea
                                            onChange={this.onchangeResponse.bind(this)}
                                            className="form-control"
                                            placeholder="Canned response text...">{this.state.response_value}</textarea>
                                    </div>
                                    <div>
                                        <input type="text"
                                               onChange={this.onchangeShortcut.bind(this)}
                                               className="form-control"
                                               value={this.state.shortcut_value}
                                               placeholder="Shortcut..."/>
                                    </div>
                                </div>

                                <div className="submit">
                                    <button
                                        onClick={this.editResponse.bind(this)}
                                        className={"btn btn-primary btn-sm mr-3  "+(this.state.button_disabled===true ? "disabled" : "")}>
                                        Save changes
                                    </button>
                                    or<a onClick={this.editFormClose.bind(this)}>Cancel</a>
                                </div>
                            </div>

                        </div>
                        <div className={" "+(this.state.editForm ? 'hide' : 'show') }>

                        <div className={"remove "+(this.state.removeMenu ? 'show' : 'hide') }>
                            <div className="container">
                                <button
                                    onClick={this.deleteResponse.bind(this)}
                                    className="btn btn-danger btn-sm mr-3"
                                >Delete this response</button>or<a onClick={this.removeMenuClose.bind(this)}>Cancel</a>
                            </div>
                        </div>
                        <div className="desc">
                            {this.props.data.message}
                        </div>
                        <div className={"menu "+(this.state.showMenu ? 'show' : 'hide') }>
                            <a onClick={this.editForm.bind(this)}>Edit</a>
                            <a onClick={this.removeMenu.bind(this)}>Remove</a>
                        </div>
                        <div className="shortcuts">
                                        <span>
                                            shortcuts
                                        </span>
                            <div className="key">#{this.props.data.shortcut}</div>
                        </div>
                        </div>

                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CannedResponse;
